<button class="btn btn-sm btn-outline-warning" (click)="clearSignature()">
  Clear
</button>

<div class="my-2" (window:resize)="size()">
  <div class="input-group" #signatureContainer>
    <signature-pad [options]="signaturePadOptions" (onEndEvent)="drawComplete()"></signature-pad>
  </div>
</div>
